import Page from './add-car';

export default Page;
